import { computed } from 'vue'
import { user } from '@/composables/useUser'
import { AccountType } from '@/gql/graphql'

export const useAccountCapabilities = () => {
  const isCompany = computed(() => currentAccountGraphqlType === AccountType.Company)

  const isWorker = computed(() => currentAccountGraphqlType === AccountType.Worker)

  const isOrganisation = computed(() => currentAccountGraphqlType === AccountType.Organisation)

  const isRecruiter = computed(() => currentAccountGraphqlType === AccountType.Recruiter)

  const isPartner = computed(() => currentAccountGraphqlType === AccountType.Partner)

  const actsAsSupplier = computed(
    () => isCompany.value && !!currentAccount?.settings?.acts_as_supplier,
  )

  const hasCompanyCapabilities = computed(() => isCompany.value)

  const hasWorkerCapabilities = computed(
    () => isWorker.value || isRecruiter.value || actsAsSupplier.value,
  )

  const hasOrganisationCapabilities = computed(() => isOrganisation.value)

  const hasRecruiterCapabilities = computed(() => isRecruiter.value || actsAsSupplier.value)

  return {
    isCompany,
    isWorker,
    isOrganisation,
    isPartner,
    isRecruiter,
    actsAsSupplier,
    hasCompanyCapabilities,
    hasWorkerCapabilities,
    hasOrganisationCapabilities,
    hasRecruiterCapabilities,
    user,
  }
}
